import request from '@/utils/request'
//自己收银台支付
export function orderMypay(data){
	return request({
	  url: '/pay/getPayInfo',
	  method: 'post',
	  data:data
	})
}
//支付
export function orderPay(data){
	return request({
	  url: '/pay/orderPay',
	  method: 'post',
	  data:data
	})
}
//enjoy支付
export function orderEnjoy(data){
	return request({
	  url: '/enjoy/pay/payOrder',
	  method: 'post',
	  data:data
	})
}
//代金券
export function getUserCoupon(data){
	return request({
	  url: '/voucherActivityUser/getInfo',
	  headers: {
	    isToken: true
	  },
	  method: 'post',
	  data:data
	})
}
export function getUserInfo(data){
	return request({
	  url: '/propMall/getUserInfo',
	  headers: {
	    isToken: true
	  },
	  method: 'post',
	  data:data
	})
}
// 获取用户全额抵扣
export function getUserCoinInfo(data){
	return request({
	  url: '/propMall/getPayCoinInfo',
	  headers: {
	    isToken: true
	  },
	  method: 'post',
	  data:data
	})
}
// 支付方式
export function getHgPayTypeInfo(){
	return request({
	  url: '/enjoy/pay/getHgPayTypeInfo',
	  method: 'get',
	})
}
//  gm币支付是否首次
export function platCoinFirst(data){
	return request({
	  url: 'pay/platCoinFirst',
	  headers: {
	    isToken: true
	  },
	  method: 'get',
		params: data
	})
}